module.exports = __webpack_public_path__ + "images/for_company_page/media_recycle_742052aa3f2865d7196a371b02033a74.png";